//i18n-setup.js
import Vue from "vue";
import VueI18n from "vue-i18n";
import axios from "axios";
import Config from "../config/index";
import store from "@/store";

Vue.use(VueI18n);

const messages = {};
const defaultLanguage = "en";

export const i18n = new VueI18n({
  locale: "", // set locale
  fallbackLocale: defaultLanguage,
  messages,
  silentTranslationWarn: true
});

function setI18nLanguage(lang) {
  i18n.locale = lang;
  axios.defaults.headers.common["Accept-Language"] = lang;
  document.querySelector("html").setAttribute("lang", lang);
  return lang;
}

export function loadLanguageAsync(lang) {
  return new Promise(resolve => {
    if (!lang) lang = "en";

    // make sure that lang 2 chars not (en-us)
    lang = lang.slice(0, 2);

    // If the same language
    if (i18n.locale === lang) {
      return resolve(setI18nLanguage(lang));
    }

    if (!lang) lang = defaultLanguage;

    // If the language was already loaded
    if (i18n.availableLocales.includes(lang)) {
      return resolve(setI18nLanguage(lang));
    }

    const supportLanguages = store.getters.getGame.supportedLanguages.split(
      "|"
    );
    if (supportLanguages.indexOf(lang) === -1) {
      console.log(
        `${lang} is not supported by the game. Game will start in default language.`
      );
      lang = "en";
    }

    fetch(`${Config.ASSET_URL}/translations/${lang}.json`)
      .then(response => response.json())
      .then(function(keyValues) {
        const trans = {};
        keyValues.forEach(keyValue => {
          trans[keyValue.key] = keyValue.translation;
        });
        messages[lang] = trans;
        i18n.setLocaleMessage(lang, trans);
        resolve(setI18nLanguage(lang));
      })
      .catch(err => {
        console.log(err);
      });
  });
}
